import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Logo } from './Logo';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Cómo funciona',
    href: '#como-funciona'
  }, {
    name: 'Alice App',
    href: '#alice-app'
  }, {
    name: 'Cursos',
    href: '#cursos'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'Preguntas frecuentes',
    href: '#faq'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-173">
      <div className="container mx-auto px-4 md:px-6" data-id="element-174">
        <div className="flex items-center justify-between" data-id="element-175">
          <a href="#inicio" className="flex-shrink-0" data-id="element-176">
            <Logo data-id="element-177" />
          </a>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-178">
            <div className="flex space-x-6" data-id="element-179">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-link-dark hover:text-link-blue transition-colors" data-id="element-180">
                  {link.name}
                </a>)}
            </div>
            <a href="#unete" className="bg-link-blue hover:bg-blue-700 text-white px-6 py-2.5 rounded-full font-medium transition-colors shadow-md shadow-link-blue/20" data-id="element-181">
              Únete a Skool
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden p-2 text-link-dark" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-182">
            {mobileMenuOpen ? <X size={24} data-id="element-183" /> : <Menu size={24} data-id="element-184" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-gray-100 py-4 px-4 flex flex-col space-y-4" data-id="element-185">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-link-dark py-2 border-b border-gray-50" onClick={() => setMobileMenuOpen(false)} data-id="element-186">
              {link.name}
            </a>)}
          <a href="#unete" className="bg-link-blue text-white text-center px-6 py-3 rounded-full font-medium mt-4" onClick={() => setMobileMenuOpen(false)} data-id="element-187">
            Únete a Skool
          </a>
        </div>}
    </nav>;
}